import React from 'react';
import classNames from 'classnames';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import { useModal } from '../../../hooks/useModal';
import { useCreateImg } from '../../../hooks/useCreateImg';
import { upperFirstLetter } from '../../../utils/helpers/helpers';
import AppLoader from '../../features/appLoader/AppLoader';
import { splitTextFromSecretSymbol } from '../../../utils/splitTextFromSecretSymbol';
import { savePostcardModalContent } from '../../../constants/copyright-modals';
import { useContent } from '../../../redux/reducer/content';
import { useRequests } from '../../../redux/reducer/requests';
import { useTranslation } from '../../../translations';

const MyGiftImageModal = React.forwardRef(function (
  {
    images,
    title,
    name,
    text,
    is_black_text,
    buttons = [{ action: 'home' }, { action: 'load', timeout: 5000, isViewDisabled: false }],
  },
  ref,
) {
  const {
    authData: { isWeb },
  } = useRequests();
  const { showMessage } = useContent();
  const { id, closeModal, addModal } = useModal();
  const { createImg, isPending } = useCreateImg();
  const { t } = useTranslation();

  const close = (closedData) => {
    closeModal(closedData ?? { id });
  };

  const buttonCallbacks = {
    home: () => {
      close();
    },
    load: () => {
      const browserData = !isWeb ? 'webView' : 'browser';

      ({
        webView: () => {
          if (showMessage) return;
          addModal({ type: 'savePostcardModal', props: savePostcardModalContent });
        },
        browser: async () => {
          const options = { width: 720, height: 1280, every: images.map(() => ({ entry: 'height' })) };

          const extraCallback = async ({ ctx, canvas }) => {
            const { width, height } = canvas;

            // Шрифты из дизайна
            const fontSemibold = new FontFace('GraphikLCG-Semibold', 'url(/fonts/GraphikLCG/GraphikLCG-Semibold.woff)');
            const fontRegular = new FontFace('GraphikLCG-Regular', 'url(/fonts/GraphikLCG/GraphikLCG-Regular.woff)');
            const fonts = await Promise.all([fontSemibold.load(), fontRegular.load()]);
            fonts.forEach((font) => document.fonts.add(font));

            ctx.fillStyle = is_black_text ? '#000000' : '#ffffff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'top';

            // константы из дизайна
            // title
            const truthTitle = t(title, { name });
            const titlesData = truthTitle.split('{{space}}');
            const fontSize = 22 * Math.min(options.width / 360, options.height / 720);
            const distanceBetweenTitleText = fontSize * 1.4;
            const x = width / 2;
            const yDataTitle = [height * 0.83, height * 0.83 + distanceBetweenTitleText];

            // константы из дизайна
            // description
            const textsData = text.split('|n|');
            const designFontSize = 14 * Math.min(options.width / 360, options.height / 720);
            const lineHeightSubText = designFontSize * 1.4;

            const yDataText = [
              yDataTitle[1] + distanceBetweenTitleText,
              yDataTitle[1] + distanceBetweenTitleText + lineHeightSubText,
            ];

            //generateTextData text
            const texts = [
              titlesData.map((titleItem, index) => ({
                font: `${fontSize}px GraphikLCG-Semibold`,
                text: !index ? upperFirstLetter(titleItem) : titleItem,
                y: yDataTitle[index],
              })),
              textsData.map((textItem, index) => ({
                font: `${designFontSize}px GraphikLCG-Regular`,
                text: textItem,
                y: yDataText[index],
              })),
            ];

            //paint text data
            texts.forEach((arr) =>
              arr.forEach(({ font, text, y }) => {
                ctx.font = font;
                ctx.fillText(text, x, y);
              }),
            );
          };

          // Тут данные для webView postMessage для скачки изображения в webView
          const {
            /*base64*/
          } = await createImg({
            imagesSrc: images,
            returnType: { type: 'download' /*if (isWeb) type: "base64"*/ },
            extraCallback,
            options,

            // if (isWeb)
            // CustomBridge.instance.send({name: "DOWNLOAD_IMG", type: 0, data: {img: base64}});
          });
        },
      })[browserData]?.();
    },
  };

  return (
    <CustomModal className={'custom-modal_fullpage'} animation={['fade']}>
      <div className={'my-gift-modal'} ref={ref}>
        <div className={'my-gift-modal__block'}>
          {images.map((src, i) => (
            <img key={`${src}-${i}`} src={src} className={'my-gift-modal__bg'} alt={''} />
          ))}

          <div className={classNames('my-gift-modal__nav', { 'my-gift-modal__nav_app': !isWeb })}>
            {buttons.map(({ action, ...otherProps }) => (
              <CustomButton
                icon={`myGift/${action}`}
                className={'button_my-gift-modal button_icon button_transparent my-gift-modal__button'}
                onClick={buttonCallbacks[action]}
                {...otherProps}
              />
            ))}
          </div>
          <div className={'my-gift-modal__footer'}>
            <h2 className={'my-gift-modal__title'}>{safeHTML(t(title, { name, space: ' ' }))}</h2>
            <div className={'my-gift-modal__text'}>{safeHTML(splitTextFromSecretSymbol(text))}</div>
          </div>
        </div>

        {isPending && <AppLoader />}
      </div>
    </CustomModal>
  );
});
export default MyGiftImageModal;
MyGiftImageModal.propTypes = {};
